import { Component } from "react";
import { Alert } from "react-bootstrap";

class DashboardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });

    try {
      console.error('[DashboardErrorBoundary] erro capturado:', {
        boundary: this.props.label || 'Home/InsideSales',
        message: error?.message,
        name: error?.name,
        stack: error?.stack,
        componentStack: info?.componentStack,
      });

      const debug = {
        ts: new Date().toISOString(),
        boundary: this.props.label || 'Home/InsideSales',
        url: window.location.href,
        message: error?.message,
        name: error?.name,
        stack: (error?.stack || '').split('\n').slice(0, 20).join('\n'),
        componentStack: (info?.componentStack || '').split('\n').slice(0, 20).join('\n'),
      };
      window.__lastDashboardError = debug;
      try {
        sessionStorage.setItem('lastDashboardError', JSON.stringify(debug));
      } catch (_) { /* ignore */ }
    } catch (_) { /* ignore */ }
  }

  render() {
    if (this.state.error) {
      const { error, info } = this.state;
      return (
        <Alert variant="danger" className="m-3">
          <Alert.Heading>Erro ao renderizar dashboard</Alert.Heading>
          <p className="mb-2">
            <strong>Dashboard (label):</strong>{' '}
            <code style={{ background: '#fff3cd', padding: '2px 6px' }}>
              {String(this.props.label || 'desconhecido')}
            </code>
          </p>
          <p className="mb-2">
            <strong>Mensagem:</strong> {String(error?.message || error)}
          </p>
          <p className="mb-2">
            <strong>Nome:</strong> {String(error?.name || 'Error')}
          </p>
          <details className="mt-2">
            <summary style={{ cursor: 'pointer' }}>Stack trace</summary>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11 }}>
              {error?.stack || 'sem stack'}
            </pre>
          </details>
          <details className="mt-2">
            <summary style={{ cursor: 'pointer' }}>Component stack (React)</summary>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11 }}>
              {info?.componentStack || 'sem component stack'}
            </pre>
          </details>
          <small className="text-muted d-block mt-2">
            Detalhes também salvos em <code>sessionStorage.lastDashboardError</code> e <code>window.__lastDashboardError</code>.
          </small>
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default DashboardErrorBoundary;
